module.exports = __webpack_public_path__ + "img/certificate_220338602_00.6b838c38.jpg";